// WIP

import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Icon from '../components/Icon';
import {
  BADGE_VARIANTS,
  BADGE_SIZE_CLASSES,
  COLOR_OPTIONS
} from './utils/constants';

/** @param {any} props */
export default function Badge({
  children,
  className = null,
  iconName = null,
  iconSize = '18px',
  removeButtonClassName = null,
  variant = 'light',
  color = 'blue',
  size = 'default',
  onDelete = null
}) {
  const isDeletable = typeof onDelete === 'function';
  return (
    <div
      className={classnames(
        'DSBadge inline-flex items-center justify-between br-pill no-select',
        `DSBadge--${size}`,
        BADGE_VARIANTS[variant][color],
        BADGE_SIZE_CLASSES[size],
        { 'DSBadge--deletable': isDeletable },
        className
      )}
      data-test-id="DSBadge"
    >
      <span
        className={classnames('DSBadge__label', {
          'inline-flex items-center gap-6': iconName
        })}
      >
        {iconName && (
          <Icon name={iconName} height={iconSize} width={iconSize} />
        )}
        {children}
      </span>
      {isDeletable && (
        <>
          <span className="DSBadge__divider bl b--stone-700 o-10" />
          <button
            className={classnames(
              'inline-flex items-center justify-center br-100 pv1 ph1 mr1',
              removeButtonClassName
            )}
            type="button"
            aria-label="Remove"
            onClick={onDelete}
          >
            <Icon name="fetch-close" height="18px" width="18px" />
          </button>
        </>
      )}
    </div>
  );
}

Badge.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  iconName: PropTypes.string,
  iconSize: PropTypes.string,
  removeButtonClassName: PropTypes.string,
  variant: PropTypes.oneOf(Object.keys(BADGE_VARIANTS)),
  color: PropTypes.oneOf(COLOR_OPTIONS),
  size: PropTypes.oneOf(Object.keys(BADGE_SIZE_CLASSES)),
  onDelete: PropTypes.func
};
